// =============================
// Imports
// =============================

import styled from 'styled-components';

import { StyledButton } from '../../global.styles';

// =============================
// Styles
// =============================

export const RegisterWrapper = styled.div`
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  padding: 4rem 0;
  width: 72rem;
`;

export const Title = styled.div`
  color: #191919;
  font-size: 1.5rem;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  margin-bottom: 2rem;
  text-align: center;
`;

export const SubTitle = styled.div`
  font-size: 1.4rem;
  margin-bottom: 3.6rem;
  text-align: center;
`;

export const TosAgreement = styled.div`
  font-size: 1.3rem;
  margin-bottom: 3.6rem;
  text-align: center;
`;

export const RegisterButton = styled(StyledButton)`
  justify-content: center;
  margin: 0 auto 2rem;
  width: 50%;
`;
